import React from "react";
import NavLink from "../molecules/NavLink";
import NavDropdown from "../molecules/NavDropdown";
import NavDropdownItem from "../molecules/NavDropdownItem";
import { useLogout } from "@/hooks";
import {
  navigationConfig,
  footerNavigationConfig,
} from "../../config/navigation";

const SidebarNav = ({ isExpanded, onMouseEnter, onMouseLeave }) => {
  const { handleLogout } = useLogout();

  const renderSeparator = (item, index) => (
    <li key={`sep-${index}`} className="px-4 pt-4 pb-1">
      {isExpanded ? (
        <span className="text-[10px] font-semibold uppercase tracking-widest text-gray-500">
          {item.label}
        </span>
      ) : (
        <div className="border-t border-gray-700 mx-2" />
      )}
    </li>
  );

  const renderNavigationItem = (item, index) => {
    if (item.type === "separator") {
      return renderSeparator(item, index);
    }

    if (item.type === "link") {
      return (
        <li key={index} className="mb-0.5">
          <NavLink
            to={item.to}
            icon={item.icon}
            iconType={item.iconType}
            isWhite={item.isWhite}
            isExpanded={isExpanded}
          >
            {item.label}
          </NavLink>
        </li>
      );
    }

    if (item.type === "logout") {
      return (
        <li key={index} className="mb-0.5">
          <NavLink
            to="#"
            icon={item.icon}
            iconType={item.iconType}
            isWhite={item.isWhite}
            isExpanded={isExpanded}
            isLogout={true}
            onLogout={handleLogout}
          >
            {item.label}
          </NavLink>
        </li>
      );
    }

    if (item.type === "dropdown") {
      return (
        <li key={index} className="mb-0.5">
          <NavDropdown
            icon={item.icon}
            iconType={item.iconType}
            isWhite={item.isWhite}
            label={item.label}
            isExpanded={isExpanded}
            dropdownId={item.label.toLowerCase()}
            items={item.items}
          >
            {item.items.map((subItem, subIndex) => (
              <NavDropdownItem
                key={subIndex}
                to={subItem.to}
                icon={subItem.icon}
                iconType={subItem.iconType}
                isWhite={subItem.isWhite}
              >
                {subItem.label}
              </NavDropdownItem>
            ))}
          </NavDropdown>
        </li>
      );
    }

    return null;
  };

  return (
    <nav
      className="h-full flex flex-col"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <ul className="flex-1 py-3 overflow-y-auto scrollbar-thin">
        {navigationConfig.map(renderNavigationItem)}
      </ul>

      {/* Footer: Sign Out separated */}
      <div className="border-t border-gray-700">
        <ul className="py-2">
          {footerNavigationConfig.map((item, index) =>
            renderNavigationItem(item, `footer-${index}`)
          )}
        </ul>
      </div>
    </nav>
  );
};

export default SidebarNav;
